/** Allowed editor origins — must stay in sync with Web::SignoffChainsController. */
export const RETURN_TO_DEPARTMENTS = 'departments'
export const RETURN_TO_SIGNOFF_MONITORING = 'signoff_monitoring'

export const RETURN_TO_ORIGINS = [RETURN_TO_DEPARTMENTS, RETURN_TO_SIGNOFF_MONITORING] as const

export type SignoffChainReturnTo = (typeof RETURN_TO_ORIGINS)[number]

export const DEFAULT_RETURN_TO: SignoffChainReturnTo = RETURN_TO_SIGNOFF_MONITORING

/** Mirror server allowlist so a bad/missing value cannot pollute breadcrumbs or the patch URL. */
export const resolveReturnTo = (returnTo: unknown): SignoffChainReturnTo => {
  const candidate = typeof returnTo === 'string' ? returnTo.trim() : returnTo
  return RETURN_TO_ORIGINS.includes(candidate as SignoffChainReturnTo)
    ? (candidate as SignoffChainReturnTo)
    : DEFAULT_RETURN_TO
}
